/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as LibraryIndexRouteImport } from './routes/library/index'
import { Route as SystemadminLayoutRouteImport } from './routes/systemadmin/_layout'
import { Route as ShareLinkIdRouteImport } from './routes/share/$linkId'
import { Route as ResetPasswordIdRouteImport } from './routes/reset-password/$id'
import { Route as SystemadminLayoutIndexRouteImport } from './routes/systemadmin/_layout/index'
import { Route as SystemadminLayoutSystemSettingsRouteImport } from './routes/systemadmin/_layout/system-settings'
import { Route as LibraryMediaPageClipIdRouteImport } from './routes/library/media-page/$clipId'
import { Route as LibraryGalleryGalleryIdRouteImport } from './routes/library/gallery/$galleryId'
import { Route as LibraryCollectionsCollectionIdRouteImport } from './routes/library/collections/$collectionId'
import { Route as SystemadminLayoutUsersIndexRouteImport } from './routes/systemadmin/_layout/users/index'
import { Route as SystemadminLayoutGroupsIndexRouteImport } from './routes/systemadmin/_layout/groups/index'
import { Route as SystemadminLayoutUsersNewRouteImport } from './routes/systemadmin/_layout/users/new'
import { Route as SystemadminLayoutPageContentMediaPageRouteImport } from './routes/systemadmin/_layout/page-content/media-page'
import { Route as SystemadminLayoutPageContentGalleryPageRouteImport } from './routes/systemadmin/_layout/page-content/gallery-page'
import { Route as SystemadminLayoutMetadataSortingAndFilteringRouteImport } from './routes/systemadmin/_layout/metadata/sorting-and-filtering'
import { Route as SystemadminLayoutMetadataFieldDefinitionsRouteImport } from './routes/systemadmin/_layout/metadata/field-definitions'
import { Route as SystemadminLayoutGroupsNewRouteImport } from './routes/systemadmin/_layout/groups/new'
import { Route as SystemadminLayoutMetadataFieldMapsIndexRouteImport } from './routes/systemadmin/_layout/metadata/field-maps/index'
import { Route as SystemadminLayoutUsersEditIdRouteImport } from './routes/systemadmin/_layout/users/edit.$id'
import { Route as SystemadminLayoutPageContentLibraryListRouteImport } from './routes/systemadmin/_layout/page-content/library/list'
import { Route as SystemadminLayoutPageContentLibraryGridRouteImport } from './routes/systemadmin/_layout/page-content/library/grid'
import { Route as SystemadminLayoutMetadataFieldMapsNewRouteImport } from './routes/systemadmin/_layout/metadata/field-maps/new'
import { Route as SystemadminLayoutGroupsEditIdRouteImport } from './routes/systemadmin/_layout/groups/edit.$id'
import { Route as LibrarySharedLinkIdMediaPageClipIdRouteImport } from './routes/library/shared/$linkId/media-page/$clipId'
import { Route as SystemadminLayoutMetadataFieldMapsEditIdRouteImport } from './routes/systemadmin/_layout/metadata/field-maps/edit.$id'

const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRoute = JobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemadminLayoutRoute = SystemadminLayoutRouteImport.update({
  id: '/systemadmin/_layout',
  path: '/systemadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareLinkIdRoute = ShareLinkIdRouteImport.update({
  id: '/share/$linkId',
  path: '/share/$linkId',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIdRoute = ResetPasswordIdRouteImport.update({
  id: '/reset-password/$id',
  path: '/reset-password/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemadminLayoutIndexRoute = SystemadminLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemadminLayoutRoute,
} as any)
const SystemadminLayoutSystemSettingsRoute =
  SystemadminLayoutSystemSettingsRouteImport.update({
    id: '/system-settings',
    path: '/system-settings',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const LibraryMediaPageClipIdRoute = LibraryMediaPageClipIdRouteImport.update({
  id: '/library/media-page/$clipId',
  path: '/library/media-page/$clipId',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryGalleryGalleryIdRoute = LibraryGalleryGalleryIdRouteImport.update({
  id: '/library/gallery/$galleryId',
  path: '/library/gallery/$galleryId',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryCollectionsCollectionIdRoute =
  LibraryCollectionsCollectionIdRouteImport.update({
    id: '/library/collections/$collectionId',
    path: '/library/collections/$collectionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemadminLayoutUsersIndexRoute =
  SystemadminLayoutUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutGroupsIndexRoute =
  SystemadminLayoutGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutUsersNewRoute =
  SystemadminLayoutUsersNewRouteImport.update({
    id: '/users/new',
    path: '/users/new',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutPageContentMediaPageRoute =
  SystemadminLayoutPageContentMediaPageRouteImport.update({
    id: '/page-content/media-page',
    path: '/page-content/media-page',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutPageContentGalleryPageRoute =
  SystemadminLayoutPageContentGalleryPageRouteImport.update({
    id: '/page-content/gallery-page',
    path: '/page-content/gallery-page',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutMetadataSortingAndFilteringRoute =
  SystemadminLayoutMetadataSortingAndFilteringRouteImport.update({
    id: '/metadata/sorting-and-filtering',
    path: '/metadata/sorting-and-filtering',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutMetadataFieldDefinitionsRoute =
  SystemadminLayoutMetadataFieldDefinitionsRouteImport.update({
    id: '/metadata/field-definitions',
    path: '/metadata/field-definitions',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutGroupsNewRoute =
  SystemadminLayoutGroupsNewRouteImport.update({
    id: '/groups/new',
    path: '/groups/new',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutMetadataFieldMapsIndexRoute =
  SystemadminLayoutMetadataFieldMapsIndexRouteImport.update({
    id: '/metadata/field-maps/',
    path: '/metadata/field-maps/',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutUsersEditIdRoute =
  SystemadminLayoutUsersEditIdRouteImport.update({
    id: '/users/edit/$id',
    path: '/users/edit/$id',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutPageContentLibraryListRoute =
  SystemadminLayoutPageContentLibraryListRouteImport.update({
    id: '/page-content/library/list',
    path: '/page-content/library/list',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutPageContentLibraryGridRoute =
  SystemadminLayoutPageContentLibraryGridRouteImport.update({
    id: '/page-content/library/grid',
    path: '/page-content/library/grid',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutMetadataFieldMapsNewRoute =
  SystemadminLayoutMetadataFieldMapsNewRouteImport.update({
    id: '/metadata/field-maps/new',
    path: '/metadata/field-maps/new',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const SystemadminLayoutGroupsEditIdRoute =
  SystemadminLayoutGroupsEditIdRouteImport.update({
    id: '/groups/edit/$id',
    path: '/groups/edit/$id',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)
const LibrarySharedLinkIdMediaPageClipIdRoute =
  LibrarySharedLinkIdMediaPageClipIdRouteImport.update({
    id: '/library/shared/$linkId/media-page/$clipId',
    path: '/library/shared/$linkId/media-page/$clipId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemadminLayoutMetadataFieldMapsEditIdRoute =
  SystemadminLayoutMetadataFieldMapsEditIdRouteImport.update({
    id: '/metadata/field-maps/edit/$id',
    path: '/metadata/field-maps/edit/$id',
    getParentRoute: () => SystemadminLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/jobs': typeof JobsRoute
  '/login': typeof LoginRoute
  '/upload': typeof UploadRoute
  '/reset-password/$id': typeof ResetPasswordIdRoute
  '/share/$linkId': typeof ShareLinkIdRoute
  '/systemadmin': typeof SystemadminLayoutRouteWithChildren
  '/library': typeof LibraryIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/library/collections/$collectionId': typeof LibraryCollectionsCollectionIdRoute
  '/library/gallery/$galleryId': typeof LibraryGalleryGalleryIdRoute
  '/library/media-page/$clipId': typeof LibraryMediaPageClipIdRoute
  '/systemadmin/system-settings': typeof SystemadminLayoutSystemSettingsRoute
  '/systemadmin/': typeof SystemadminLayoutIndexRoute
  '/systemadmin/groups/new': typeof SystemadminLayoutGroupsNewRoute
  '/systemadmin/metadata/field-definitions': typeof SystemadminLayoutMetadataFieldDefinitionsRoute
  '/systemadmin/metadata/sorting-and-filtering': typeof SystemadminLayoutMetadataSortingAndFilteringRoute
  '/systemadmin/page-content/gallery-page': typeof SystemadminLayoutPageContentGalleryPageRoute
  '/systemadmin/page-content/media-page': typeof SystemadminLayoutPageContentMediaPageRoute
  '/systemadmin/users/new': typeof SystemadminLayoutUsersNewRoute
  '/systemadmin/groups': typeof SystemadminLayoutGroupsIndexRoute
  '/systemadmin/users': typeof SystemadminLayoutUsersIndexRoute
  '/library/shared/$linkId/media-page/$clipId': typeof LibrarySharedLinkIdMediaPageClipIdRoute
  '/systemadmin/groups/edit/$id': typeof SystemadminLayoutGroupsEditIdRoute
  '/systemadmin/metadata/field-maps/new': typeof SystemadminLayoutMetadataFieldMapsNewRoute
  '/systemadmin/page-content/library/grid': typeof SystemadminLayoutPageContentLibraryGridRoute
  '/systemadmin/page-content/library/list': typeof SystemadminLayoutPageContentLibraryListRoute
  '/systemadmin/users/edit/$id': typeof SystemadminLayoutUsersEditIdRoute
  '/systemadmin/metadata/field-maps': typeof SystemadminLayoutMetadataFieldMapsIndexRoute
  '/systemadmin/metadata/field-maps/edit/$id': typeof SystemadminLayoutMetadataFieldMapsEditIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/jobs': typeof JobsRoute
  '/login': typeof LoginRoute
  '/upload': typeof UploadRoute
  '/reset-password/$id': typeof ResetPasswordIdRoute
  '/share/$linkId': typeof ShareLinkIdRoute
  '/library': typeof LibraryIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/library/collections/$collectionId': typeof LibraryCollectionsCollectionIdRoute
  '/library/gallery/$galleryId': typeof LibraryGalleryGalleryIdRoute
  '/library/media-page/$clipId': typeof LibraryMediaPageClipIdRoute
  '/systemadmin/system-settings': typeof SystemadminLayoutSystemSettingsRoute
  '/systemadmin': typeof SystemadminLayoutIndexRoute
  '/systemadmin/groups/new': typeof SystemadminLayoutGroupsNewRoute
  '/systemadmin/metadata/field-definitions': typeof SystemadminLayoutMetadataFieldDefinitionsRoute
  '/systemadmin/metadata/sorting-and-filtering': typeof SystemadminLayoutMetadataSortingAndFilteringRoute
  '/systemadmin/page-content/gallery-page': typeof SystemadminLayoutPageContentGalleryPageRoute
  '/systemadmin/page-content/media-page': typeof SystemadminLayoutPageContentMediaPageRoute
  '/systemadmin/users/new': typeof SystemadminLayoutUsersNewRoute
  '/systemadmin/groups': typeof SystemadminLayoutGroupsIndexRoute
  '/systemadmin/users': typeof SystemadminLayoutUsersIndexRoute
  '/library/shared/$linkId/media-page/$clipId': typeof LibrarySharedLinkIdMediaPageClipIdRoute
  '/systemadmin/groups/edit/$id': typeof SystemadminLayoutGroupsEditIdRoute
  '/systemadmin/metadata/field-maps/new': typeof SystemadminLayoutMetadataFieldMapsNewRoute
  '/systemadmin/page-content/library/grid': typeof SystemadminLayoutPageContentLibraryGridRoute
  '/systemadmin/page-content/library/list': typeof SystemadminLayoutPageContentLibraryListRoute
  '/systemadmin/users/edit/$id': typeof SystemadminLayoutUsersEditIdRoute
  '/systemadmin/metadata/field-maps': typeof SystemadminLayoutMetadataFieldMapsIndexRoute
  '/systemadmin/metadata/field-maps/edit/$id': typeof SystemadminLayoutMetadataFieldMapsEditIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/jobs': typeof JobsRoute
  '/login': typeof LoginRoute
  '/upload': typeof UploadRoute
  '/reset-password/$id': typeof ResetPasswordIdRoute
  '/share/$linkId': typeof ShareLinkIdRoute
  '/systemadmin/_layout': typeof SystemadminLayoutRouteWithChildren
  '/library/': typeof LibraryIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/library/collections/$collectionId': typeof LibraryCollectionsCollectionIdRoute
  '/library/gallery/$galleryId': typeof LibraryGalleryGalleryIdRoute
  '/library/media-page/$clipId': typeof LibraryMediaPageClipIdRoute
  '/systemadmin/_layout/system-settings': typeof SystemadminLayoutSystemSettingsRoute
  '/systemadmin/_layout/': typeof SystemadminLayoutIndexRoute
  '/systemadmin/_layout/groups/new': typeof SystemadminLayoutGroupsNewRoute
  '/systemadmin/_layout/metadata/field-definitions': typeof SystemadminLayoutMetadataFieldDefinitionsRoute
  '/systemadmin/_layout/metadata/sorting-and-filtering': typeof SystemadminLayoutMetadataSortingAndFilteringRoute
  '/systemadmin/_layout/page-content/gallery-page': typeof SystemadminLayoutPageContentGalleryPageRoute
  '/systemadmin/_layout/page-content/media-page': typeof SystemadminLayoutPageContentMediaPageRoute
  '/systemadmin/_layout/users/new': typeof SystemadminLayoutUsersNewRoute
  '/systemadmin/_layout/groups/': typeof SystemadminLayoutGroupsIndexRoute
  '/systemadmin/_layout/users/': typeof SystemadminLayoutUsersIndexRoute
  '/library/shared/$linkId/media-page/$clipId': typeof LibrarySharedLinkIdMediaPageClipIdRoute
  '/systemadmin/_layout/groups/edit/$id': typeof SystemadminLayoutGroupsEditIdRoute
  '/systemadmin/_layout/metadata/field-maps/new': typeof SystemadminLayoutMetadataFieldMapsNewRoute
  '/systemadmin/_layout/page-content/library/grid': typeof SystemadminLayoutPageContentLibraryGridRoute
  '/systemadmin/_layout/page-content/library/list': typeof SystemadminLayoutPageContentLibraryListRoute
  '/systemadmin/_layout/users/edit/$id': typeof SystemadminLayoutUsersEditIdRoute
  '/systemadmin/_layout/metadata/field-maps/': typeof SystemadminLayoutMetadataFieldMapsIndexRoute
  '/systemadmin/_layout/metadata/field-maps/edit/$id': typeof SystemadminLayoutMetadataFieldMapsEditIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/jobs'
    | '/login'
    | '/upload'
    | '/reset-password/$id'
    | '/share/$linkId'
    | '/systemadmin'
    | '/library'
    | '/reset-password'
    | '/library/collections/$collectionId'
    | '/library/gallery/$galleryId'
    | '/library/media-page/$clipId'
    | '/systemadmin/system-settings'
    | '/systemadmin/'
    | '/systemadmin/groups/new'
    | '/systemadmin/metadata/field-definitions'
    | '/systemadmin/metadata/sorting-and-filtering'
    | '/systemadmin/page-content/gallery-page'
    | '/systemadmin/page-content/media-page'
    | '/systemadmin/users/new'
    | '/systemadmin/groups'
    | '/systemadmin/users'
    | '/library/shared/$linkId/media-page/$clipId'
    | '/systemadmin/groups/edit/$id'
    | '/systemadmin/metadata/field-maps/new'
    | '/systemadmin/page-content/library/grid'
    | '/systemadmin/page-content/library/list'
    | '/systemadmin/users/edit/$id'
    | '/systemadmin/metadata/field-maps'
    | '/systemadmin/metadata/field-maps/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/jobs'
    | '/login'
    | '/upload'
    | '/reset-password/$id'
    | '/share/$linkId'
    | '/library'
    | '/reset-password'
    | '/library/collections/$collectionId'
    | '/library/gallery/$galleryId'
    | '/library/media-page/$clipId'
    | '/systemadmin/system-settings'
    | '/systemadmin'
    | '/systemadmin/groups/new'
    | '/systemadmin/metadata/field-definitions'
    | '/systemadmin/metadata/sorting-and-filtering'
    | '/systemadmin/page-content/gallery-page'
    | '/systemadmin/page-content/media-page'
    | '/systemadmin/users/new'
    | '/systemadmin/groups'
    | '/systemadmin/users'
    | '/library/shared/$linkId/media-page/$clipId'
    | '/systemadmin/groups/edit/$id'
    | '/systemadmin/metadata/field-maps/new'
    | '/systemadmin/page-content/library/grid'
    | '/systemadmin/page-content/library/list'
    | '/systemadmin/users/edit/$id'
    | '/systemadmin/metadata/field-maps'
    | '/systemadmin/metadata/field-maps/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/callback'
    | '/jobs'
    | '/login'
    | '/upload'
    | '/reset-password/$id'
    | '/share/$linkId'
    | '/systemadmin/_layout'
    | '/library/'
    | '/reset-password/'
    | '/library/collections/$collectionId'
    | '/library/gallery/$galleryId'
    | '/library/media-page/$clipId'
    | '/systemadmin/_layout/system-settings'
    | '/systemadmin/_layout/'
    | '/systemadmin/_layout/groups/new'
    | '/systemadmin/_layout/metadata/field-definitions'
    | '/systemadmin/_layout/metadata/sorting-and-filtering'
    | '/systemadmin/_layout/page-content/gallery-page'
    | '/systemadmin/_layout/page-content/media-page'
    | '/systemadmin/_layout/users/new'
    | '/systemadmin/_layout/groups/'
    | '/systemadmin/_layout/users/'
    | '/library/shared/$linkId/media-page/$clipId'
    | '/systemadmin/_layout/groups/edit/$id'
    | '/systemadmin/_layout/metadata/field-maps/new'
    | '/systemadmin/_layout/page-content/library/grid'
    | '/systemadmin/_layout/page-content/library/list'
    | '/systemadmin/_layout/users/edit/$id'
    | '/systemadmin/_layout/metadata/field-maps/'
    | '/systemadmin/_layout/metadata/field-maps/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CallbackRoute: typeof CallbackRoute
  JobsRoute: typeof JobsRoute
  LoginRoute: typeof LoginRoute
  UploadRoute: typeof UploadRoute
  ResetPasswordIdRoute: typeof ResetPasswordIdRoute
  ShareLinkIdRoute: typeof ShareLinkIdRoute
  SystemadminLayoutRoute: typeof SystemadminLayoutRouteWithChildren
  LibraryIndexRoute: typeof LibraryIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  LibraryCollectionsCollectionIdRoute: typeof LibraryCollectionsCollectionIdRoute
  LibraryGalleryGalleryIdRoute: typeof LibraryGalleryGalleryIdRoute
  LibraryMediaPageClipIdRoute: typeof LibraryMediaPageClipIdRoute
  LibrarySharedLinkIdMediaPageClipIdRoute: typeof LibrarySharedLinkIdMediaPageClipIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systemadmin/_layout': {
      id: '/systemadmin/_layout'
      path: '/systemadmin'
      fullPath: '/systemadmin'
      preLoaderRoute: typeof SystemadminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$linkId': {
      id: '/share/$linkId'
      path: '/share/$linkId'
      fullPath: '/share/$linkId'
      preLoaderRoute: typeof ShareLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$id': {
      id: '/reset-password/$id'
      path: '/reset-password/$id'
      fullPath: '/reset-password/$id'
      preLoaderRoute: typeof ResetPasswordIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systemadmin/_layout/': {
      id: '/systemadmin/_layout/'
      path: '/'
      fullPath: '/systemadmin/'
      preLoaderRoute: typeof SystemadminLayoutIndexRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/system-settings': {
      id: '/systemadmin/_layout/system-settings'
      path: '/system-settings'
      fullPath: '/systemadmin/system-settings'
      preLoaderRoute: typeof SystemadminLayoutSystemSettingsRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/library/media-page/$clipId': {
      id: '/library/media-page/$clipId'
      path: '/library/media-page/$clipId'
      fullPath: '/library/media-page/$clipId'
      preLoaderRoute: typeof LibraryMediaPageClipIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/gallery/$galleryId': {
      id: '/library/gallery/$galleryId'
      path: '/library/gallery/$galleryId'
      fullPath: '/library/gallery/$galleryId'
      preLoaderRoute: typeof LibraryGalleryGalleryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/collections/$collectionId': {
      id: '/library/collections/$collectionId'
      path: '/library/collections/$collectionId'
      fullPath: '/library/collections/$collectionId'
      preLoaderRoute: typeof LibraryCollectionsCollectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systemadmin/_layout/users/': {
      id: '/systemadmin/_layout/users/'
      path: '/users'
      fullPath: '/systemadmin/users'
      preLoaderRoute: typeof SystemadminLayoutUsersIndexRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/groups/': {
      id: '/systemadmin/_layout/groups/'
      path: '/groups'
      fullPath: '/systemadmin/groups'
      preLoaderRoute: typeof SystemadminLayoutGroupsIndexRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/users/new': {
      id: '/systemadmin/_layout/users/new'
      path: '/users/new'
      fullPath: '/systemadmin/users/new'
      preLoaderRoute: typeof SystemadminLayoutUsersNewRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/page-content/media-page': {
      id: '/systemadmin/_layout/page-content/media-page'
      path: '/page-content/media-page'
      fullPath: '/systemadmin/page-content/media-page'
      preLoaderRoute: typeof SystemadminLayoutPageContentMediaPageRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/page-content/gallery-page': {
      id: '/systemadmin/_layout/page-content/gallery-page'
      path: '/page-content/gallery-page'
      fullPath: '/systemadmin/page-content/gallery-page'
      preLoaderRoute: typeof SystemadminLayoutPageContentGalleryPageRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/metadata/sorting-and-filtering': {
      id: '/systemadmin/_layout/metadata/sorting-and-filtering'
      path: '/metadata/sorting-and-filtering'
      fullPath: '/systemadmin/metadata/sorting-and-filtering'
      preLoaderRoute: typeof SystemadminLayoutMetadataSortingAndFilteringRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/metadata/field-definitions': {
      id: '/systemadmin/_layout/metadata/field-definitions'
      path: '/metadata/field-definitions'
      fullPath: '/systemadmin/metadata/field-definitions'
      preLoaderRoute: typeof SystemadminLayoutMetadataFieldDefinitionsRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/groups/new': {
      id: '/systemadmin/_layout/groups/new'
      path: '/groups/new'
      fullPath: '/systemadmin/groups/new'
      preLoaderRoute: typeof SystemadminLayoutGroupsNewRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/metadata/field-maps/': {
      id: '/systemadmin/_layout/metadata/field-maps/'
      path: '/metadata/field-maps'
      fullPath: '/systemadmin/metadata/field-maps'
      preLoaderRoute: typeof SystemadminLayoutMetadataFieldMapsIndexRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/users/edit/$id': {
      id: '/systemadmin/_layout/users/edit/$id'
      path: '/users/edit/$id'
      fullPath: '/systemadmin/users/edit/$id'
      preLoaderRoute: typeof SystemadminLayoutUsersEditIdRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/page-content/library/list': {
      id: '/systemadmin/_layout/page-content/library/list'
      path: '/page-content/library/list'
      fullPath: '/systemadmin/page-content/library/list'
      preLoaderRoute: typeof SystemadminLayoutPageContentLibraryListRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/page-content/library/grid': {
      id: '/systemadmin/_layout/page-content/library/grid'
      path: '/page-content/library/grid'
      fullPath: '/systemadmin/page-content/library/grid'
      preLoaderRoute: typeof SystemadminLayoutPageContentLibraryGridRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/metadata/field-maps/new': {
      id: '/systemadmin/_layout/metadata/field-maps/new'
      path: '/metadata/field-maps/new'
      fullPath: '/systemadmin/metadata/field-maps/new'
      preLoaderRoute: typeof SystemadminLayoutMetadataFieldMapsNewRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/systemadmin/_layout/groups/edit/$id': {
      id: '/systemadmin/_layout/groups/edit/$id'
      path: '/groups/edit/$id'
      fullPath: '/systemadmin/groups/edit/$id'
      preLoaderRoute: typeof SystemadminLayoutGroupsEditIdRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
    '/library/shared/$linkId/media-page/$clipId': {
      id: '/library/shared/$linkId/media-page/$clipId'
      path: '/library/shared/$linkId/media-page/$clipId'
      fullPath: '/library/shared/$linkId/media-page/$clipId'
      preLoaderRoute: typeof LibrarySharedLinkIdMediaPageClipIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systemadmin/_layout/metadata/field-maps/edit/$id': {
      id: '/systemadmin/_layout/metadata/field-maps/edit/$id'
      path: '/metadata/field-maps/edit/$id'
      fullPath: '/systemadmin/metadata/field-maps/edit/$id'
      preLoaderRoute: typeof SystemadminLayoutMetadataFieldMapsEditIdRouteImport
      parentRoute: typeof SystemadminLayoutRoute
    }
  }
}

interface SystemadminLayoutRouteChildren {
  SystemadminLayoutSystemSettingsRoute: typeof SystemadminLayoutSystemSettingsRoute
  SystemadminLayoutIndexRoute: typeof SystemadminLayoutIndexRoute
  SystemadminLayoutGroupsNewRoute: typeof SystemadminLayoutGroupsNewRoute
  SystemadminLayoutMetadataFieldDefinitionsRoute: typeof SystemadminLayoutMetadataFieldDefinitionsRoute
  SystemadminLayoutMetadataSortingAndFilteringRoute: typeof SystemadminLayoutMetadataSortingAndFilteringRoute
  SystemadminLayoutPageContentGalleryPageRoute: typeof SystemadminLayoutPageContentGalleryPageRoute
  SystemadminLayoutPageContentMediaPageRoute: typeof SystemadminLayoutPageContentMediaPageRoute
  SystemadminLayoutUsersNewRoute: typeof SystemadminLayoutUsersNewRoute
  SystemadminLayoutGroupsIndexRoute: typeof SystemadminLayoutGroupsIndexRoute
  SystemadminLayoutUsersIndexRoute: typeof SystemadminLayoutUsersIndexRoute
  SystemadminLayoutGroupsEditIdRoute: typeof SystemadminLayoutGroupsEditIdRoute
  SystemadminLayoutMetadataFieldMapsNewRoute: typeof SystemadminLayoutMetadataFieldMapsNewRoute
  SystemadminLayoutPageContentLibraryGridRoute: typeof SystemadminLayoutPageContentLibraryGridRoute
  SystemadminLayoutPageContentLibraryListRoute: typeof SystemadminLayoutPageContentLibraryListRoute
  SystemadminLayoutUsersEditIdRoute: typeof SystemadminLayoutUsersEditIdRoute
  SystemadminLayoutMetadataFieldMapsIndexRoute: typeof SystemadminLayoutMetadataFieldMapsIndexRoute
  SystemadminLayoutMetadataFieldMapsEditIdRoute: typeof SystemadminLayoutMetadataFieldMapsEditIdRoute
}

const SystemadminLayoutRouteChildren: SystemadminLayoutRouteChildren = {
  SystemadminLayoutSystemSettingsRoute: SystemadminLayoutSystemSettingsRoute,
  SystemadminLayoutIndexRoute: SystemadminLayoutIndexRoute,
  SystemadminLayoutGroupsNewRoute: SystemadminLayoutGroupsNewRoute,
  SystemadminLayoutMetadataFieldDefinitionsRoute:
    SystemadminLayoutMetadataFieldDefinitionsRoute,
  SystemadminLayoutMetadataSortingAndFilteringRoute:
    SystemadminLayoutMetadataSortingAndFilteringRoute,
  SystemadminLayoutPageContentGalleryPageRoute:
    SystemadminLayoutPageContentGalleryPageRoute,
  SystemadminLayoutPageContentMediaPageRoute:
    SystemadminLayoutPageContentMediaPageRoute,
  SystemadminLayoutUsersNewRoute: SystemadminLayoutUsersNewRoute,
  SystemadminLayoutGroupsIndexRoute: SystemadminLayoutGroupsIndexRoute,
  SystemadminLayoutUsersIndexRoute: SystemadminLayoutUsersIndexRoute,
  SystemadminLayoutGroupsEditIdRoute: SystemadminLayoutGroupsEditIdRoute,
  SystemadminLayoutMetadataFieldMapsNewRoute:
    SystemadminLayoutMetadataFieldMapsNewRoute,
  SystemadminLayoutPageContentLibraryGridRoute:
    SystemadminLayoutPageContentLibraryGridRoute,
  SystemadminLayoutPageContentLibraryListRoute:
    SystemadminLayoutPageContentLibraryListRoute,
  SystemadminLayoutUsersEditIdRoute: SystemadminLayoutUsersEditIdRoute,
  SystemadminLayoutMetadataFieldMapsIndexRoute:
    SystemadminLayoutMetadataFieldMapsIndexRoute,
  SystemadminLayoutMetadataFieldMapsEditIdRoute:
    SystemadminLayoutMetadataFieldMapsEditIdRoute,
}

const SystemadminLayoutRouteWithChildren =
  SystemadminLayoutRoute._addFileChildren(SystemadminLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CallbackRoute: CallbackRoute,
  JobsRoute: JobsRoute,
  LoginRoute: LoginRoute,
  UploadRoute: UploadRoute,
  ResetPasswordIdRoute: ResetPasswordIdRoute,
  ShareLinkIdRoute: ShareLinkIdRoute,
  SystemadminLayoutRoute: SystemadminLayoutRouteWithChildren,
  LibraryIndexRoute: LibraryIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  LibraryCollectionsCollectionIdRoute: LibraryCollectionsCollectionIdRoute,
  LibraryGalleryGalleryIdRoute: LibraryGalleryGalleryIdRoute,
  LibraryMediaPageClipIdRoute: LibraryMediaPageClipIdRoute,
  LibrarySharedLinkIdMediaPageClipIdRoute:
    LibrarySharedLinkIdMediaPageClipIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
